module.exports = __webpack_public_path__ + "static/media/1015370.fc4c8abb.png";